import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyBj3djyjySlfPRX8d80ti-0h9F2uebzV5s',
  authDomain: 'firemenu-admin.firebaseapp.com',
  projectId: 'firemenu-admin',
  storageBucket: 'firemenu-admin.appspot.com',
  messagingSenderId: '713794141188',
  appId: '1:713794141188:web:aa8b1d54ded1c68e464951',
  measurementId: 'G-9PFYWZ7B2M',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth();
auth.useDeviceLanguage();

export const db = initializeFirestore(app, {});

// enableIndexedDbPersistence(db).catch((err) => {
//   if (err.code === 'failed-precondition') {
//     // eslint-disable-next-line no-console
//     console.log('failed-precondition');
//     // Multiple tabs open, persistence can only be enabled
//     // in one tab at a a time.
//     // ...
//   } else if (err.code === 'unimplemented') {
//     // eslint-disable-next-line no-console
//     console.log('unimplemented');
//     // The current browser does not support all of the
//     // features required to enable persistence
//     // ...
//   }
// });

export const storage = getStorage();

export const functions = getFunctions();
